import axios from 'axios';

const baseURL = '/public_api';

const restApi = axios.create({baseURL});

export default restApi;
